import React, { useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { EmailSentContainer, ResendCode } from "./EmailSent.styles";
import { InfoMessage, TitleSubtitle } from "../..";
import { Button as MuiButton } from "@mui/material";
import { Button } from "../../Button/Button"
import { resendConfirmationEmail } from "../../../services/AuthenticationService";
import { useRegisterContext } from "../../../contexts/RegisterContext";
import { ButtonContainer, ButtonIcon, ButtonLabel, CTABackAndForthContainer } from "../../../pages/Register/Register.styles";

interface EmailSentProps extends WithRouterProps {
    onPrevButtonClick: Function;
}

const EmailSent: React.FC<EmailSentProps> = ({onPrevButtonClick
}) => {

    const { registerInfo } = useRegisterContext();
    const [emailResent, setEmailResent] = useState<boolean>(false);

    const handleResendConfirmationEmail = () => {
        setEmailResent(false);
        resendConfirmationEmail(registerInfo.user.email).then(() => {
            setEmailResent(true);
        });
    }

    return (
        <EmailSentContainer>
            <TitleSubtitle
                data-cy="register-verify-email-title"
                size="sm"
                centered
                title="Verify Your Email"
                subTitle={`We have just sent a confirmation email to ${registerInfo.user.email}`} />

            <ResendCode>
                Didn’t get it? Check spam folder or
                <MuiButton
                    variant="text"
                    style={{ textTransform: 'none' }}
                    onClick={handleResendConfirmationEmail}>
                    Resend email
                </MuiButton>
            </ResendCode>
            {emailResent && (
                    <InfoMessage
                        variant="info"
                        hasBackground={true}
                        message="We tried to resend the email. Please check again in both Inbox and Spam folders!"
                    />
                )}
                <CTABackAndForthContainer>
                <Button
                    size="md"
                    variant="tertiary"
                    onClick={() => onPrevButtonClick()}
                    data-cy="button-basicInfo-back"
                    sx={{ padding: 0 }}
                >
                    <ButtonContainer>
                        <ButtonIcon icon="ArrowLeft" />
                        <ButtonLabel>Back</ButtonLabel>
                    </ButtonContainer>
                </Button>
            </CTABackAndForthContainer>
        </EmailSentContainer>
    );
};

EmailSent.displayName = "EmailSent";

const ComponentWithRouter = withRouter(EmailSent)

export { ComponentWithRouter as EmailSent };
